// Auth actions
export const AUTH_SAVE = 'AUTH_SAVE';
export const AUTH_CLEAR = 'AUTH_CLEAR';

// Common actions
export const COMMON_ALERT = 'COMMON_ALERT';
export const COMMON_CLOSE_ALERT = 'COMMON_CLOSE_ALERT';
export const COMMON_MODAL_RESIZE = 'COMMON_MODAL_RESIZE';

// Header actions
export const HEADER_TITLE = 'HEADER_TITLE';
export const HEADER_BACK = 'HEADER_BACK';

// Login actions
// None

// User (non-global) actions
export const USER_SET = 'USER_SET';

// User (global) actions
export const USER_LOGOUT = 'USER_LOGOUT';

// Videos actions
export const VIDEOS_LIST = 'VIDEOS_LIST';
export const VIDEOS_SET_CURRENT = 'VIDEOS_SET_CURRENT';


// WEBPACK FOOTER //
// ./src/constants/actions.jsx